import { jsx as _jsx } from "react/jsx-runtime";
var ConferenceTabTitle = function ConferenceTabTitle(_ref) {
  var isActive = _ref.isActive,
    title = _ref.title,
    onClick = _ref.onClick,
    className = _ref.className;
  return _jsx("div", Object.assign({
    onClick: onClick,
    className: className
  }, {
    children: function () {
      if (typeof title === 'function') {
        return title(isActive);
      }
      return title;
    }()
  }));
};
export default ConferenceTabTitle;